module.exports = __webpack_public_path__ + "static/media/photo183.7783a2ae.jpg";